import type { DatasetImageUploadProps } from "./dataset-image-upload.type";
import type { DatasetImageCreateVariables } from "@/entities/dataset";
import type {
  UploadCustomRequest,
  UploadFileProps,
} from "@/modules/upload-file";

import { DATASET_TYPE } from "@/entities/dataset";
import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";
import { createUploadFileFromFile } from "@/modules/upload-file";

const datasetType = DATASET_TYPE.IMAGE;

export const useDatasetImageUpload = ({
  template,
  onFileUploaded,
  loading,
  ...customUploadProps
}: DatasetImageUploadProps) => {
  const { addMutatorItem } = useDatasetsMutatorSync();

  const customRequest: UploadCustomRequest = async ({ file }) => {
    if (typeof file === "string" || !("uid" in file)) return;

    const variables: DatasetImageCreateVariables = {
      type: datasetType,
      name: file.name,
      data: file,
      layout_index: template.layout_index,
    };

    addMutatorItem({
      mutationType: "create",
      datasetType,
      variables,
      uniqueKey: file.name,
    });

    const newFile = await createUploadFileFromFile(file);
    if (newFile) onFileUploaded?.(newFile);
  };

  const uploadProps: UploadFileProps = {
    multiple: true,
    type: "image",
    ...customUploadProps,
    customRequest,
  };

  return {
    uploadProps,
    loading,
  };
};
